function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from 'react';
import { withMedia } from 'react-media-query-hoc';
import smoothscroll from 'smoothscroll-polyfill';
import { ChevronLeftIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import * as styles from './slider.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getCurrentCardNumber = (children, scrollPosition) => {
  var currentCardNumber = 0;
  var currentCard = children[0];
  while (scrollPosition - currentCard.getBoundingClientRect().x >= currentCard.getBoundingClientRect().width) {
    currentCardNumber += 1;
    currentCard = children[currentCardNumber];
  }
  return currentCardNumber;
};
var Slider = _ref => {
  var cards = _ref.cards,
    _ref$onTapLeftChevron = _ref.onTapLeftChevron,
    onTapLeftChevron = _ref$onTapLeftChevron === void 0 ? () => {} : _ref$onTapLeftChevron,
    _ref$onTapRightChevro = _ref.onTapRightChevron,
    onTapRightChevron = _ref$onTapRightChevro === void 0 ? () => {} : _ref$onTapRightChevro;
  var cardWindowRef = useRef(null);
  var cardListRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    leftScrollButtonVisible = _useState2[0],
    setLeftScrollButtonVisible = _useState2[1];
  var _useState3 = useState(cards.length > 1),
    _useState4 = _slicedToArray(_useState3, 2),
    rightScrollButtonVisible = _useState4[0],
    setRightScrollButtonVisible = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    cardPosition = _useState6[0],
    setCardPosition = _useState6[1];
  useEffect(() => {
    smoothscroll.polyfill();
  }, []);
  var getCurrentCard = () => {
    var _cardListRef$current;
    return (_cardListRef$current = cardListRef.current) === null || _cardListRef$current === void 0 ? void 0 : _cardListRef$current.children[cardPosition];
  };
  return ___EmotionJSX("div", {
    ref: cardWindowRef,
    css: styles.cardsContainer
  }, ___EmotionJSX("button", {
    css: styles.scrollBtnLeft,
    "aria-label": "previous",
    type: "button",
    style: {
      opacity: leftScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      if (cardListRef.current) {
        var _getCurrentCard, _cardWindowRef$curren, _cardListRef$current2;
        var currentCardX = (_getCurrentCard = getCurrentCard()) === null || _getCurrentCard === void 0 ? void 0 : _getCurrentCard.getBoundingClientRect().x;
        var windowX = (_cardWindowRef$curren = cardWindowRef.current) === null || _cardWindowRef$curren === void 0 ? void 0 : _cardWindowRef$curren.getBoundingClientRect().x;
        var aligned = currentCardX === windowX;
        var targetCardNum = aligned && cardPosition > 0 ? cardPosition - 1 : cardPosition;
        var nextCard = (_cardListRef$current2 = cardListRef.current) === null || _cardListRef$current2 === void 0 ? void 0 : _cardListRef$current2.children[targetCardNum];
        nextCard === null || nextCard === void 0 ? void 0 : nextCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
      onTapLeftChevron();
    }
  }, ___EmotionJSX(ChevronLeftIcon, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })), ___EmotionJSX("button", {
    css: styles.scrollBtnRight,
    "aria-label": "next",
    type: "button",
    style: {
      opacity: rightScrollButtonVisible ? 100 : 0
    },
    onClick: () => {
      if (cardListRef.current && cardPosition < cards.length - 1) {
        var _cardListRef$current3;
        var nextCard = (_cardListRef$current3 = cardListRef.current) === null || _cardListRef$current3 === void 0 ? void 0 : _cardListRef$current3.children[cardPosition + 1];
        nextCard === null || nextCard === void 0 ? void 0 : nextCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        });
      }
      onTapRightChevron();
    }
  }, ___EmotionJSX(ChevronRightIcon, {
    css: styles.scrollButtonIcon,
    size: "custom"
  })), ___EmotionJSX("div", {
    css: styles.cardWindow,
    onScroll: evt => {
      if (evt.target instanceof Element) {
        var currentCardNumber = getCurrentCardNumber(evt.target.children[0].children, evt.target.getBoundingClientRect().x);
        if (currentCardNumber !== cardPosition) {
          setCardPosition(currentCardNumber);
        }
        setLeftScrollButtonVisible(evt.target.scrollLeft > 10);
        setRightScrollButtonVisible(cards.length > 1 && evt.target.scrollLeft <= evt.target.scrollWidth - evt.target.clientWidth - 10);
      }
    }
  }, ___EmotionJSX("div", {
    ref: cardListRef,
    css: styles.cardList
  }, cards)));
};
var SliderWithMedia = withMedia(Slider);
export { SliderWithMedia as Slider };